export const checkIsPublicHoliday = (holidays, date) => {
  const isHoliday = holidays.some((holiday) => holiday.holidayDate.startsWith(date));
  return isHoliday;
};
